import Vue from 'vue';
import { Module } from 'vuex';
import { RootState } from '@/types/store';

export declare namespace ShopV3 {
    /** 订单状态 pending--支付完成(待填地址)， preparing--已下单，upload--已开始备货 sent--已发货 */
    type OrderStatus = 'pending' | 'preparing' | 'upload' | 'sent';
    /** '固定商品规格' | '可选商品规格' | '邀请商品规格' | '盲盒商品' */
    type OrderType = 'package_gift' | 'optional_package_gift' | 'invite_gift' | 'blind_box_gift'
    interface OrderItem {
        id: number
        status: OrderStatus
        type: OrderType,
        name: string
        spec: Record<string, string>
        image: string
        express_company: string
        express_number: string
        can_change_before: string
        activity_name: string
    }
    interface OrderDetail {
        id : number
        status: string
        type: string
        name: string
        image: string
        spec: string
        express_company: string
        express_number: string
        created_at: string
        pay_time: string
    }
    interface OrderGift {
        confirm_word: string
        id: number
        name: string
        size_table: string
        spec_1: string
        spec_2: string
        spec_3: string
    }
}

export interface ShopV3State {
    orderList: ListWrap<ShopV3.OrderItem> & ListReq
    orderDetail: Record<string, Array<ShopV3.OrderDetail>>
    specMap: Record<number, Equipment.ChoiceItem>
}

export const shopV3Store: Module<ShopV3State, RootState> = {
    namespaced: true,
    state: {
        orderList: {
            list: [],
            req: false,
            loaded: false
        },
        orderDetail: {},
        specMap: {},
    },
    mutations: {
        concatOrderList(state, { offset, list, forceUpdate }: {forceUpdate: boolean; offset: number; list: Array<ShopV3.OrderItem>}) {
            if(forceUpdate) {
                state.orderList.list = state.orderList.list.slice(0, list.length)
            }
            list.forEach((ele, key) => {
                Vue.set(state.orderList.list, key + offset, ele)
            });
        },
        setOrderListReq(state, req) {
            state.orderList.req = req;
        },
        setOrderListLoaded(state, loaded) {
            state.orderList.loaded = loaded;
        },
        setOrderDetail(state, { detail, orderId }: { orderId: string; detail: ShopV3.OrderDetail }) {
            Vue.set(state.orderDetail, orderId, detail)
        },
    },
    actions: {
        /**
         * 获取活动列表
         */
        async getOrderList(context, { offset, count , forceUpdate}) {
            const wrap = context.state.orderList;
            if(forceUpdate) {
                wrap.req = wrap.loaded = false;
            }
            if(wrap.req || wrap.loaded) {
                return;
            }
            context.commit('setOrderListReq', true)
            const response = await Vue.axios.get('/api/v3/gift/list', {
                params: {
                    offset, count
                }
            });
            const rdata = response.data;
            context.commit('setOrderListReq', false)
            if (rdata.status === 0) {
                const list = rdata.data;
                context.commit('concatOrderList', {
                    list,
                    offset,
                    forceUpdate
                });
                if(list.length < count) {
                    context.commit('setOrderListLoaded', true)
                }
            }
            return rdata;
        },
        /**
         * 获取订单详情
         */
        async getOrderDetail({ commit }, { orderId }) {
            const response = await Vue.axios.get('/api/v3/gift/detail', {
                params: {
                    activity_id: orderId,
                    // form_path: location.href
                },
            });
            const rdata = response.data;
            if (rdata.status === 0) {
                commit('setOrderDetail', { orderId, detail: rdata.data });
            }
            return rdata;
        },
        /**
         * 获取订单详情
         */
        async updateInfo({ commit }, { 
            /** 订单id */
            id,
            /** 收件人 */
            name,
            /** 收件人性别 */
            gender,
            /**  收件人年龄 */
            age,
            /** 收件人电话 */
            mobile,
            district,
            /** 收件人地址 */
            address,
            /** 选择规格id */
            specification,
         }) {
            const response = await Vue.axios.post('/api/v3/gift/order', {
                id,
                name,
                gender,
                age,
                mobile,
                district_1_id: district?.[0],
                district_2_id: district?.[1],
                district_3_id: district?.[2],
                address,
                specification,
            });
            const rdata = response.data;
            return rdata;
        },
    },
};